import request from '@/utils/request'

// 新增参数配置
export function writeDataPoint (data) {
  return request({
    url: '/gather/device/info/writeDataPoint',
    method: 'post',
    data: data
  })
}

/**
 * @desc 发送十六进制数据
 * @param {  } 
 * @version: 1.0.0
 */
export function sendHex (data) {
  return request({
    url: '/gather/device/info/devTest',
    method: 'post',
    data: data
  })
}
